import { createTheme } from '@mui/material/styles';
import { red, blue, green, amber, grey } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: blue[800],
      light: blue[500],
      dark: blue[900],
    },
    secondary: {
      main: '#C4D8EF',
      light: '#E6F4FF',
      dark: '#B4C4F0',
    },
    error: {
      main: red[800],
      light: red[500],
      dark: red[900],
    },
    warning: {
      main: amber[800],
      light: amber[500],
      dark: amber[900],
    },
    success: {
      main: green[800],
      light: green[500],
      dark: green[900],
    },
    neutral: {
      main: grey[800],
      light: grey[500],
      dark: grey[900],
    },
  },
  typography: {
    fontFamily: ['Inter', 'sans-serif'].join(','),
    h1: {
      fontSize: '3.2rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2.4rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: '1.5',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          transition: 'all 0.2s ease-in-out',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
});

export default theme;
